import AppTheme from 'docs/src/modules/components/AppTheme';
import ForgotPassword from 'docs/src/pages/premium-themes/onepirate/ForgotPassword';

export default function Page() {
  return (
    <AppTheme title="Onepirate theme - MUI" description="A onepirate theme">
      <ForgotPassword />
    </AppTheme>
  );
}
